var MdAutocompleteController = /** @class */ (function () {
    function MdAutocompleteController($scope, $state, SearchService, TypeaheadService) {
        'ngInject';
        this.recentSearchesType = false;
        this.recentSearches = [];
        this.searchTerm = null;
        this.$scope = $scope;
        this.$state = $state;
        this.SearchService = SearchService;
        this.TypeaheadService = TypeaheadService;
    }
    MdAutocompleteController.prototype.$onInit = function () {
        var _this = this;
        this.$scope.$watch(function () {
            return _this.SearchService.clickedSearchTerm;
        }, function (term) {
            _this.$scope.searchText = _this.searchTerm = (term === '*' ? '' : term);
        });
    };
    MdAutocompleteController.prototype.searchNow = function (text) {
        if (text.length > 0) {
            var flag = this.SearchService.isMobileDevice();
            if (flag) {
                var element = document.getElementsByTagName('md-virtual-repeat-container');
                var index = void 0;
                for (index = element.length - 1; index >= 0; index--) {
                    element[index].parentNode.removeChild(element[index]);
                }
            }
            var state = {
                term: text,
                ff: text,
                fft: 'term'
            };
            this.$state.go('advSearchResults', state, { inherit: false }); // switch views to the results page.
        }
    };
    MdAutocompleteController.prototype.getMatches = function (searchText) {
        // RECENT SEARCHES
        if (this.SearchService.recentSearchesModels.length === 0 && searchText === '') {
            searchText = '*';
            this.recentSearchesType = false;
        }
        else if (searchText === '') {
            this.recentSearchesType = true;
            return this.SearchService.recentSearchesModels;
        }
        this.recentSearchesType = false;
        // Get the type ahead data models
        return this.TypeaheadService.typeahead(searchText);
    };
    return MdAutocompleteController;
}());
export { MdAutocompleteController };
//# sourceMappingURL=MdAutocomplete.controller.js.map